import { type ReactNode } from "react";
import { StatsigProvider, useClientAsyncInit } from "@statsig/react-bindings";
import { getClientBootstrapValues } from "./statsig";

export function ExperimentProvider({ children }: { children: ReactNode }) {
  const { userInfo } = getClientBootstrapValues();

  const { client } = useClientAsyncInit(
    import.meta.env.VITE_STATSIG_CLIENT_KEY,
    userInfo,
    { environment: { tier: import.meta.env.MODE } },
  );

  return <StatsigProvider client={client}>{children}</StatsigProvider>;
}
